import React from 'react';
import validate from 'validate.js';
import { FormattedMessage } from 'react-intl';

const validateSurveillanceForm = ({
  has_surveillance = false,
  surveillance_description = ''
}) => {
  return {
    has_surveillance: validate.single(has_surveillance,
      {
        presence: {
          allowEmpty: false,
          message: <FormattedMessage id="hosting.validate_surveillance_form.camera_disclosure" defaultMessage="Please disclose any cameras or recording devices"/>
        }
      }),
    surveillance_description: validate.single(surveillance_description,
      {
        presence: {
          allowEmpty: !has_surveillance,
          message: <FormattedMessage id="hosting.validate_surveillance_form.description" defaultMessage="Please enter a description"/>
        },
        length: {
          minimum: 50,
          tooShort: <FormattedMessage id="hosting.validate_surveillance_form.minimum_characters" defaultMessage="Minimum 50 characters"/>,
          maximum: 1000,
          tooLong: <FormattedMessage id="hosting.validate_surveillance_form.maximum_characters" defaultMessage="Maximum 1000 characters"/>
        }
      })
  };
};

export default validateSurveillanceForm;
